'use client'

import React, { useRef } from 'react';
import ButtonGroupItem from '@/components/ui/ButtonGroupItem/ButtonGroupItem';
import LinkButton from '@/components/ui/LinkButton/LinkButton';
import { LanguageType, LanguageDirection } from '@/lib/types';
// import { useLocation } from 'react-router-dom';
import { useAnimatedNavigate } from '@/hooks/useAnimatedNavigation';



import { debug } from '@/lib/debug';
import { useIsLg, useIsTb } from '@/contexts/BreakpointContext';
interface FooterSectionProps {
  language: LanguageType;
  setLanguage: (language: string) => void;
  footerRef?: React.RefObject<HTMLDivElement | null>;
  // brandInfoSectionPageData: BrandInfoSectionContent;
}

const LANGUAGE_TO_DIRECTION: Record<LanguageType, LanguageDirection> = {
  english: "ltr",
  arabic: "rtl"
};

const LPFooterSection: React.FC<FooterSectionProps> = ({
  language,
  setLanguage,
  footerRef,
  // aspectRatio,
  // brandInfoSectionPageData
}) => {
  // const isLg = useIsLg();
  // const isTb = useIsTb();
  // const location = useLocation();
  const navigate = useAnimatedNavigate();
  // const sunRef = useRef<HTMLDivElement>(null);
  const lineRef = useRef<HTMLDivElement>(null);

  // debug.log('footer section rerender');


  return (
    <footer ref={footerRef} className='
        footer-section
        w-full
        px-[1.25rem]
        padding-main-x-desktop
        pb-[1.5rem]
        tb:pb-0
        flex items-center justify-center
        '
      style={{
        // display: isLg ? 'none' : 'flex',
        display: 'flex',
        // position: isLg ? 'fixed' : 'relative',
        // bottom: 0,
        // left: 0,
        // right: 0,
      }}
    >

      <div className='
           w-full max-w-full container-large
           flex flex-col gap-[2.5rem] lg:gap-[7rem]
          '>

        <div
          style={{ direction: LANGUAGE_TO_DIRECTION[language] }}
          className='
              flex flex-col
              gap-y-[3.5rem]
              lg:gap-y-[4.5rem]
            '>
          <div className='
              flex flex-col 
              gap-[2rem]
              '>
            <div className='
                flex flex-col lg:flex-row items-end justify-between
                gap-[2rem] lg:gap-[1rem]
                '>
              <div className='w-full lg:min-w-[24.3125rem] flex items-center justify-center lg:justify-start'>
                <p className='text-36-to-24--neue-june text-text-tertiary text-center lg:text-left'>
                  {language === 'arabic' ? "جوهر الجمال" : "Essence of beauty"}
                </p>
              </div>

              <div className='w-full lg:min-w-[24.3125rem] flex items-center justify-center lg:justify-end lg:items-end'>
                <div className='flex flex-col lg:flex-row gap-[0.75rem] items-center'>
                  <p className='text-16--alexandria text-text-primary'>
                    {language === 'arabic' ? 'اللغه' : 'Language'}:
                  </p>
                  <div className='flex flex-row gap-[0.5rem] lg:gap-[0.25rem]'>
                    <ButtonGroupItem text="English" itemType='narrow' size={16} onClick={() => setLanguage('EN')} isSelected={language === 'english'} />
                    <ButtonGroupItem text="العربيه" itemType='narrow' size={16} onClick={() => setLanguage('AR')} isSelected={language === 'arabic'} />
                  </div>
                </div>
              </div>
            </div>

            <div className="relative pointer-events-none">
              <div ref={lineRef} className="h-[1.5px] bg-stroke-soft-200 relative z-10"></div>

            </div>

            <div className='
                flex flex-col lg:flex-row items-center justify-between
                gap-[1rem]
                z-10
              '>
              <div className='text-16--alexandria text-text-primary'>
                <p
                  style={{ direction: LANGUAGE_TO_DIRECTION[language] }}
                  className='text-16--alexandria text-text-primary whitespace-nowrap'>
                  {language === 'arabic' ? `© ${new Date().getFullYear()} ريڤيڤ. جميع الحقوق محفوظة.` : `© ${new Date().getFullYear()} Rivive. All rights reserved.`}
                </p>
              </div>

              <div className='w-full flex items-center justify-center lg:justify-end'>
                <div
                  style={{ direction: "ltr" }}
                  className='flex flex-row flex-wrap lg:flex-row gap-[1rem] lg:gap-[2rem] items-center justify-center'>
                  <LinkButton text={language === 'arabic' ? 'الشروط والأحكام' : 'Terms & Conditions'} size={16} onClick={() => navigate('/legal')} language={language} />
                  <LinkButton text={language === 'arabic' ? 'سياسة الخصوصيه' : 'Privacy Policy'} size={16} onClick={() => navigate('/legal')} language={language} />
                  <LinkButton text={language === 'arabic' ? 'سياسة ملفات تعريف الإرتباط' : 'Cookies Policy'} size={16} onClick={() => navigate('/legal')} language={language} />
                </div>
              </div>
            </div>
          </div>

          <div className='w-full'>
            <img src="/Logotype-Wide.svg" alt="Logotype wide" className="w-full" />
          </div>
        </div>

      </div>

    </footer>
  );
};

export default LPFooterSection; 
